import request from '@/api/request';
// ids is an array of vehicles
// fromTime, toTime is Date 2010
export function getDailyReporting (data) {
  return request({
    url: '/report/daily',
    method: 'post',
    data
  });
}

export function getTripReporting (data) {
  return request({
    url: '/report/trip',
    method: 'post',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/reporting.js